/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_ErrorsInputs */

const en_privacy_section_2_item_errors = /** @type {(inputs: Privacy_Section_2_Item_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error tracking data`)
};

const lv_privacy_section_2_item_errors = /** @type {(inputs: Privacy_Section_2_Item_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kļūdu izsekošanas dati`)
};

/**
* | output |
* | --- |
* | "Error tracking data" |
*
* @param {Privacy_Section_2_Item_ErrorsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_errors = /** @type {((inputs?: Privacy_Section_2_Item_ErrorsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_ErrorsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_errors(inputs)
	return en_privacy_section_2_item_errors(inputs)
});